"use strict";

require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = PasswordModern;
Object.defineProperty(exports, "validations", {
  enumerable: true,
  get: function get() {
    return _validations.validations;
  }
});
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.array.concat.js");
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _formElements = require("@evidation/form-elements");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _icons = require("@evidation/ui/lib/icons");
var _ui = require("@evidation/ui");
var _utils = require("../../components/utils");
var _validations = require("./validations");
var _useTranslated = require("../../hooks/useTranslated");
var _excluded = ["error", "onChange"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var PasswordWrapper = (0, _styledComponents["default"])(_ui.Flex).withConfig({
  displayName: "passwordModern__PasswordWrapper"
})(["position:relative;"]);
var PasswordVisibilityIconWrapper = _styledComponents["default"].div.withConfig({
  displayName: "passwordModern__PasswordVisibilityIconWrapper"
})(["position:absolute;right:0;"]);
var VisibilityBtn = _styledComponents["default"].button.withConfig({
  displayName: "passwordModern__VisibilityBtn"
})(["background:transparent;border:0;outline:none;padding:6px;margin-right:6px;"]);
/**
 *
 * If at any point we need these 2 icons anywhere else
 * we can move them to our icons setup in the UI package.
 */
var EyeClosed = function EyeClosed() {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: "18",
    height: "16",
    viewBox: "0 0 18 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.4025 7.49647C16.7159 6.04999 15.8988 4.8703 14.9513 3.95741L13.9575 4.95116C14.7679 5.72557 15.4737 6.73866 16.0841 8.00038C14.4591 11.3637 12.1525 12.9613 9.00011 12.9613C8.05389 12.9613 7.18234 12.8156 6.38546 12.5242L5.30871 13.601C6.41548 14.112 7.64595 14.3676 9.00011 14.3676C12.754 14.3676 15.5548 12.4125 17.4025 8.50233C17.4767 8.34508 17.5153 8.17332 17.5153 7.9994C17.5153 7.82549 17.4767 7.65373 17.4025 7.49647ZM16.1609 1.23397L15.3282 0.400379C15.3137 0.385852 15.2965 0.374327 15.2775 0.366464C15.2586 0.358601 15.2382 0.354553 15.2177 0.354553C15.1972 0.354553 15.1768 0.358601 15.1579 0.366464C15.1389 0.374327 15.1217 0.385852 15.1071 0.400379L12.971 2.53554C11.7933 1.93397 10.4696 1.63319 9.00011 1.63319C5.24621 1.63319 2.44543 3.58827 0.597769 7.49843C0.523502 7.65569 0.484985 7.82744 0.484985 8.00135C0.484985 8.17527 0.523502 8.34702 0.597769 8.50428C1.33592 10.059 2.22459 11.3051 3.26378 12.2428L1.19699 14.309C1.16771 14.3383 1.15126 14.378 1.15126 14.4194C1.15126 14.4608 1.16771 14.5006 1.19699 14.5299L2.03078 15.3637C2.06008 15.3929 2.0998 15.4094 2.14123 15.4094C2.18265 15.4094 2.22238 15.3929 2.25168 15.3637L16.1609 1.45507C16.1754 1.44056 16.1869 1.42332 16.1948 1.40435C16.2026 1.38539 16.2067 1.36505 16.2067 1.34452C16.2067 1.32399 16.2026 1.30365 16.1948 1.28469C16.1869 1.26572 16.1754 1.24848 16.1609 1.23397ZM1.91613 8.00038C3.54308 4.6371 5.84972 3.03944 9.00011 3.03944C10.0653 3.03944 11.0339 3.22225 11.9126 3.59393L10.5396 4.96698C9.88931 4.62003 9.14476 4.49127 8.41575 4.59969C7.68674 4.7081 7.01188 5.04796 6.49072 5.56911C5.96957 6.09027 5.62971 6.76513 5.5213 7.49414C5.41288 8.22315 5.54164 8.9677 5.88859 9.61796L4.25929 11.2473C3.35753 10.4514 2.58019 9.37303 1.91613 8.00038ZM6.73449 8.00038C6.73483 7.65597 6.81641 7.31651 6.97259 7.00955C7.12878 6.7026 7.35517 6.43682 7.63338 6.2338C7.91158 6.03077 8.23375 5.89624 8.57372 5.84113C8.91369 5.78601 9.26186 5.81186 9.58996 5.91659L6.8382 8.66835C6.76923 8.45241 6.73424 8.22706 6.73449 8.00038Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.92216 10.1877C8.85459 10.1877 8.78798 10.1846 8.72197 10.1785L7.69033 11.2102C8.31082 11.4478 8.98685 11.5006 9.63671 11.3622C10.2866 11.2238 10.8824 10.9001 11.3523 10.4303C11.8221 9.96048 12.1458 9.36462 12.2842 8.71476C12.4226 8.0649 12.3697 7.38887 12.1321 6.76838L11.1005 7.80002C11.1065 7.86603 11.1097 7.93264 11.1097 8.00021C11.1098 8.28752 11.0533 8.57205 10.9435 8.83751C10.8336 9.10298 10.6725 9.34419 10.4693 9.54735C10.2661 9.75051 10.0249 9.91163 9.75946 10.0215C9.494 10.1314 9.20947 10.1879 8.92216 10.1877Z",
    fill: "#1A1A1A"
  }));
};
var EyeOpen = function EyeOpen() {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: "18",
    height: "14",
    viewBox: "0 0 18 14",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.4023 6.49609C15.5508 2.5957 12.7519 0.632812 8.99999 0.632812C5.24608 0.632812 2.44921 2.5957 0.597647 6.49805C0.52338 6.65531 0.484863 6.82706 0.484863 7.00098C0.484863 7.17489 0.52338 7.34665 0.597647 7.50391C2.44921 11.4043 5.24804 13.3672 8.99999 13.3672C12.7539 13.3672 15.5508 11.4043 17.4023 7.50195C17.5527 7.18555 17.5527 6.81836 17.4023 6.49609ZM8.99999 11.9609C5.8496 11.9609 3.54296 10.3633 1.91601 7C3.54296 3.63672 5.8496 2.03906 8.99999 2.03906C12.1504 2.03906 14.457 3.63672 16.084 7C14.459 10.3633 12.1523 11.9609 8.99999 11.9609ZM8.92187 3.5625C7.02343 3.5625 5.48437 5.10156 5.48437 7C5.48437 8.89844 7.02343 10.4375 8.92187 10.4375C10.8203 10.4375 12.3594 8.89844 12.3594 7C12.3594 5.10156 10.8203 3.5625 8.92187 3.5625ZM8.92187 9.1875C7.71288 9.1875 6.73437 8.20898 6.73437 7C6.73437 5.79102 7.71288 4.8125 8.92187 4.8125C10.1309 4.8125 11.1094 5.79102 11.1094 7C11.1094 8.20898 10.1309 9.1875 8.92187 9.1875Z"
  }));
};
var Rule = function Rule(_ref) {
  var success = _ref.success,
    translationKey = _ref.translationKey;
  var message = (0, _useTranslated.useTranslated)(translationKey);
  return /*#__PURE__*/_react["default"].createElement(_ui.Flex, {
    items: "center",
    style: {
      marginBottom: '.4rem'
    }
  }, /*#__PURE__*/_react["default"].createElement(_icons.CheckCircleFilled, {
    style: {
      marginRight: '1rem',
      color: success ? _ui.color.text.success : _ui.color.states.disabled
    }
  }), ' ', /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      color: _ui.color.text.secondary
    }
  }, message));
};
function PasswordModern(props) {
  var passwordPlaceholder = (0, _useTranslated.useTranslated)('components.password.password');
  var passwordValidatingText = (0, _useTranslated.useTranslated)('components.password.validating');
  var passwordText = (0, _useTranslated.useTranslated)('components.password.password');
  var _useState = (0, _react.useState)(''),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    visible = _useState4[0],
    setVisible = _useState4[1];
  var _props$meta$asyncVali = props.meta.asyncValidating,
    asyncValidating = _props$meta$asyncVali === void 0 ? false : _props$meta$asyncVali,
    label = props.label;
  var _util_commonInputPara = (0, _utils.util_commonInputParamters)(props),
    _util_commonInputPara2 = _util_commonInputPara.error,
    error = _util_commonInputPara2 === void 0 ? '' : _util_commonInputPara2,
    onChange = _util_commonInputPara.onChange,
    fieldProps = (0, _objectWithoutProperties2["default"])(_util_commonInputPara, _excluded);
  var isValidByRuleIndex = (0, _react.useMemo)(function () {
    return _validations.passwordRules.map(function (rule) {
      return value ? rule.regex.test(value) : false;
    });
  }, [value]);
  var isInvalid = isValidByRuleIndex.includes(false);
  var handleValueChange = (0, _react.useCallback)(function (val) {
    setValue(val);
    if (!isInvalid) {
      var _props$input;
      // TODO:JRA
      // curious panda does not like optional chaining
      // suspect this due to babel configuration.
      // eslint-disable-next-line
      props === null || props === void 0 ? void 0 : (_props$input = props.input) === null || _props$input === void 0 ? void 0 : _props$input.onChange(val);
    }
  }, [props.input, isInvalid]);
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_formElements.InputLabel, {
    style: {
      display: 'block',
      fontWeight: 400,
      fontSize: 14
    }
  }, /*#__PURE__*/_react["default"].createElement(_formElements.MarkdownHtml, null, label)), /*#__PURE__*/_react["default"].createElement(PasswordWrapper, {
    items: "center"
  }, /*#__PURE__*/_react["default"].createElement(_formElements.TextInput, (0, _extends2["default"])({}, fieldProps, {
    value: value,
    label: undefined,
    placeholder: props.placeholder || passwordPlaceholder,
    onChange: function onChange(evt) {
      return handleValueChange(evt.target.value);
    },
    type: visible ? 'text' : 'password'
  })), /*#__PURE__*/_react["default"].createElement(PasswordVisibilityIconWrapper, null, /*#__PURE__*/_react["default"].createElement(VisibilityBtn, {
    type: "button",
    onClick: function onClick() {
      return setVisible(!visible);
    }
  }, visible ? /*#__PURE__*/_react["default"].createElement(EyeClosed, null) : /*#__PURE__*/_react["default"].createElement(EyeOpen, null)))), asyncValidating && /*#__PURE__*/_react["default"].createElement(_formElements.InputLabel, {
    id: 't-passwordConfirm-message',
    style: {
      color: 'gray'
    }
  }, "".concat(passwordValidatingText, " ").concat(passwordText), "..."), !asyncValidating && error !== '' && /*#__PURE__*/_react["default"].createElement(_formElements.InputError, {
    id: 't-passwordConfirm-message'
  }, error), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginLeft: 16,
      marginTop: 8
    }
  }, _validations.passwordRules.map(function (rule, id) {
    return /*#__PURE__*/_react["default"].createElement(Rule, {
      success: isValidByRuleIndex[id],
      translationKey: rule.translationKey,
      key: "password_rule_label_".concat(id)
    });
  })));
}
PasswordModern.handlesErrorDisplay = true;